module.exports = __webpack_public_path__ + "static/img/Silver_badge.bc3cf59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Silver_badge.png
// module id = 984
// module chunks = 1